<script setup lang="ts">
import { Carousel, Slide } from "vue3-carousel";
import { ref } from "vue";
import { useNewsFetcher } from "@/composables/use-news";

const ITEMS_COUNT = 6;

const { data: items, pending: loading } = await useAsyncData("news-items", () => useNewsFetcher(ITEMS_COUNT));

const newsCarousel = ref(ITEMS_COUNT);

const carouselConfig = {
  settings: {
    itemsToShow: 1.2,
    snapAlign: "center",
  },
  breakpoints: {
    280: {
      itemsToShow: 1.2,
      snapAlign: "center",
    },
    700: {
      itemsToShow: 2.2,
      snapAlign: "center",
    },
    900: {
      itemsToShow: 2.2,
      snapAlign: "start",
    },
  },
};
</script>

<template>
  <section class="bg-gray-light pt-50 pb-200 md:pb-100">
    <div class="container">
      <h1 class="flex items-center text-dark-blue mb-40">
        <span class="mr-80">Nyheter</span>
        <svgo-logo-sm-round class="w-135" />
      </h1>

      <div class="relative max-h-[480px]">
        <client-only>
          <template v-if="items?.length > 0">
            <carousel
              v-bind="carouselConfig"
              :breakpoints="carouselConfig.breakpoints"
              ref="newsCarousel"
              class="m-auto overflow-hidden"
            >
              <slide v-for="(item, i) in items" :key="i" :index="i" class="pr-20">
                <NewsArticleItem2 :item="item" />
              </slide>
            </carousel>
          </template>
          <template v-else-if="loading">
            <p>Loading news...</p>
            <!-- Loading state -->
          </template>
          <template v-else>
            <p>No news available.</p>
            <!-- Fallback if no items are fetched -->
          </template>
        </client-only>

        <div class="absolute right-0 -bottom-80 md:-bottom-60 flex justify-center">
          <div class="flex justify-center" v-if="newsCarousel">
            <svgo-arr-l @click="newsCarousel.prev()" width="40" class="mx-8 cursor-pointer" />
            <svgo-arr-r @click="newsCarousel.next()" width="40" class="mx-8 cursor-pointer" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Add your styles here */
</style>
